export { default as LogoImage } from './codeleap_logo_black.png'
export { default as Placeholder } from './placeholder.png'
export { default as loadingAnimation } from '../images/loadingAnimation.json'
export { default as LogoTemplate } from './logo-template.png'
export { default as LogoTemplateMobile } from './logo-template-mobile.png'
export { default as Onboarding1 } from './onboarding1.png'
export { default as Onboarding2 } from './onboarding2.png'
export { default as RocketImage } from './rocket.jpeg'
export { default as HomeImage } from './home.png'
export { default as SignUp } from './SignUp.png'
export { default as EmptyBox } from './emptyBox.png'
export { default as MagnifyingGlass } from './magnifying_glass.png'
export { default as AvatarExample } from './avatar_example.png'
export { default as LogoWhite } from './logo-white.png'
export { default as LogoBlack } from './logo-black.png'
export { default as LogoPng } from './logo.png'
export { default as Welcome } from './welcome.png'
export { default as LogoName } from './logo_name.png'
export { default as LogoIcon } from './logo-icon.png'
export { default as LogoIconWhite } from './logo-icon-white.png'
export { default as NotificationIcon } from './notification_icon.png'
export { default as AccessHubHeader } from './access_hub_header.png'
export { default as AccessHubHeaderMobile } from './access_hub_header_mobile.png'
